export enum ThirdPartyCompanyDefaultField {
  'accountOwner' = 'accountOwner',
  'customerStatus' = 'customerStatus',
  'monthlySpend' = 'monthlySpend',
  'renewalDate' = 'renewalDate',
  'renewalRisk' = 'renewalRisk',
}

enum FieldType {
  'boolean' = 'boolean',
  'number' = 'number',
  'date' = 'date',
  'string' = 'string',
}

export enum IntegrationsKeyMap {
  hubspot = 'hubspotCompanyID',
  intercom = 'intercomCompanyID',
  salesforce = 'salesforceAccountID',
  segment = 'segmentGroupID',
  zendesk = 'zendeskOrganizationID',
}

type DefaultField = {
  name: ThirdPartyCompanyDefaultField;
  type: FieldType;
};

const DefaultFieldMap: Record<ThirdPartyCompanyDefaultField, DefaultField> = {
  [ThirdPartyCompanyDefaultField.monthlySpend]: {
    name: ThirdPartyCompanyDefaultField.monthlySpend,
    type: FieldType.number,
  },
  [ThirdPartyCompanyDefaultField.renewalDate]: {
    name: ThirdPartyCompanyDefaultField.renewalDate,
    type: FieldType.date,
  },
  [ThirdPartyCompanyDefaultField.renewalRisk]: {
    name: ThirdPartyCompanyDefaultField.renewalRisk,
    type: FieldType.string,
  },
  [ThirdPartyCompanyDefaultField.accountOwner]: {
    name: ThirdPartyCompanyDefaultField.accountOwner,
    type: FieldType.string,
  },
  [ThirdPartyCompanyDefaultField.customerStatus]: {
    name: ThirdPartyCompanyDefaultField.customerStatus,
    type: FieldType.string,
  },
};

export const DefaultFields = Object.values(DefaultFieldMap);
